import type { CityVenue } from './venueDetailApi';

export type RelatedVenuePlacement = {
  delivery_token: string;
  venue: CityVenue;
};

type RelatedVenuePlacementEnvelope = {
  data: RelatedVenuePlacement[];
};

function jsonHeaders(): HeadersInit {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
}

export async function fetchRelatedVenuePlacement(
  cityRef: string,
  contextVenueId: string,
  pageViewId: string,
  signal?: AbortSignal,
): Promise<RelatedVenuePlacement | null> {
  const params = new URLSearchParams({
    surface: 'related_venues',
    context_venue_id: contextVenueId,
    page_view_id: pageViewId,
  });
  const response = await fetch(`/api/v1/cities/${encodeURIComponent(cityRef)}/commercial/placements?${params.toString()}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    signal,
  });
  if (!response.ok) {
    throw new Error(`Related venue placement request failed (${response.status})`);
  }
  const payload = await response.json() as RelatedVenuePlacementEnvelope;
  const placement = payload.data?.[0] ?? null;
  if (!placement?.delivery_token || !placement.venue?.id) {
    return null;
  }
  return placement;
}

export async function recordRelatedVenuePlacementEvent(
  deliveryToken: string,
  kind: 'visible_impression' | 'open',
): Promise<void> {
  const response = await fetch('/api/v1/commercial/events', {
    method: 'POST',
    credentials: 'same-origin',
    headers: jsonHeaders(),
    body: JSON.stringify({
      delivery_token: deliveryToken,
      kind,
      client_event_at: new Date().toISOString(),
    }),
    keepalive: kind === 'open',
  });
  if (!response.ok) {
    throw new Error(`Related venue placement event failed (${response.status})`);
  }
}
